<template>
  <div>
    <!-- Banner do Imóvel -->
    <BannerImovel
      title="Sobrado próximo ao Horto"
      description="4 dormitórios, 1 suíte, 3 vagas na garagem e churrasqueira"
      bannerImage="/casaRegina/fachada-6.jpeg"
    />
  
    <!-- Conteúdo dentro de um container -->
      <PropertyPriceComponent 
        :price="780000"
        whatsapp-number="5511992954545"
        :default-interest-rate="9.75"
      />
      <AtributosImovelComponent :atributos="[
        { icone: 'mdi-home', texto: '4 dormitórios (1 suíte)' },
        { icone: 'mdi-car', texto: '3 vagas cobertas' },
        { icone: 'mdi-car', texto: '1 vaga aberta' },
        { icone: 'mdi-sofa', texto: 'sala de estar' },
        { icone: 'mdi-shower', texto: '3 banheiros, 1 lavabo' },
        { icone: 'mdi-tumble-dryer', texto: 'Espaço para lavanderia' },
        { icone: 'mdi-door', texto: 'Quartinho' },
        { icone: 'mdi-stove', texto: 'Cozinha ampla' },
        { icone: 'mdi-grill', texto: 'Churrasqueira' },
        { icone: 'mdi-balcony', texto: 'Varanda' },
      ]"/>
      <NegociacoesComponent :negociacoes="[
        { icone: 'mdi-handshake', texto: 'Negocia'},
        { icone: 'mdi-home-export-outline', texto: 'Aceita Imóvel'},
        { icone: 'mdi-car', texto: 'Aceita Veículo'},
      ]"/>
      <DocumentationComponent />
    
    <SectionGalleryComponent :gallerySections="casaReginaData" />
    
    <!-- Video Tour Section -->
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <h2 class="text-h4 text-center mb-6">Tour Virtual</h2>
          <VideoComponent
            video-src="https://www.youtube.com/embed/4cbbBNxJurw?si=1Bg6CagEICpfoHZh"
            title="Tour Completo da Residência"
          />
        </v-col>
      </v-row>
    </v-container>
  
    <MapaImovelComponent
      :latitude="-23.4565702"
      :longitude="-46.6270753"
      rua="Rua São Cleto"
      numero="495"
      bairro="Vila Irmãos Arnoni"
      cidade="São Paulo"
      estado="SP"
      cep="02375-000"
    />
  </div>
</template>

<script>
import BannerImovel from "@/components/BannerImovel.vue";
import AtributosImovelComponent from "@/components/AtributosImovelComponent.vue";
import SectionGalleryComponent from "@/components/SectionGalleryComponent.vue";
import MapaImovelComponent from "@/components/MapaImovelComponent.vue";
import DocumentationComponent from "@/components/DocumentationComponent.vue";
import PropertyPriceComponent from "@/components/PropertyPriceComponent.vue";
import VideoComponent from '@/components/VideoComponent.vue'
import NegociacoesComponent from '@/components/NegociacoesComponent.vue'
import { useMeta } from 'vue-meta';

// Data
import casaReginaData from "@/data/casaRegina.js";

export default {
  name: "ImovelDetailsPage",
  components: {
    BannerImovel,
    AtributosImovelComponent,
    SectionGalleryComponent,
    MapaImovelComponent,
    DocumentationComponent,
    PropertyPriceComponent,
    VideoComponent,
    NegociacoesComponent,
  },
  setup() {
    const { meta } = useMeta({
      title: 'Casa à Venda no Horto Florestal, Zona Norte de São Paulo | 4 Quartos, 3 Vagas | RRamos Consultoria',
      meta: [
        {
          name: 'description',
          content: 'Casa espaçosa à venda na Zona Norte de São Paulo, próxima ao Horto Florestal e Serra da Cantareira. 4 dormitórios, suíte, churrasqueira e 3 vagas cobertas. Financiamento disponível!'
        },
        {
          name: 'keywords',
          content: 'casa à venda, zona norte SP, horto florestal, serra da cantareira, imóvel SP, comprar casa SP, financiamento imóvel, imobiliária zona norte, RRamos Consultoria'
        },
        {
          name: 'robots',
          content: 'index, follow'
        },
        {
          property: 'og:title',
          content: 'Casa à Venda no Horto Florestal, Zona Norte de São Paulo | 4 Quartos, 3 Vagas'
        },
        {
          property: 'og:description',
          content: 'Linda casa no Horto Florestal, com 4 dormitórios, 1 suíte, churrasqueira, 3 vagas cobertas e excelente localização na Zona Norte de SP.'
        },
        {
          property: 'og:image',
          content: 'https://rramosconsultoria.com.br/imagens/imovel-horto-florestal.jpg'
        },
        {
          property: 'og:url',
          content: 'https://rramosconsultoria.com.br/imovel-sao-cleto'
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          name: 'twitter:title',
          content: 'Casa à Venda no Horto Florestal, Zona Norte de São Paulo'
        },
        {
          name: 'twitter:description',
          content: 'Casa ampla com 4 dormitórios, suíte, churrasqueira e 3 vagas cobertas. Localizada na Zona Norte, perto da Serra da Cantareira.'
        },
        {
          name: 'twitter:image',
          content: 'https://rramosconsultoria.com.br/imagens/imovel-horto-florestal.jpg'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://rramosconsultoria.com.br/imovel-sao-cleto'
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "RealEstateListing",
            "name": "Casa à Venda no Horto Florestal, Zona Norte de São Paulo",
            "description": "Imóvel exclusivo na Zona Norte de SP, com 4 dormitórios, suíte, churrasqueira, 3 vagas cobertas e excelente localização perto do Horto Florestal e Serra da Cantareira.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Rua São Cleto, 495",
              "addressLocality": "Vila Irmãos Arnoni",
              "addressRegion": "SP",
              "postalCode": "02375-000",
              "addressCountry": "BR"
            },
            "image": "https://rramosconsultoria.com.br/imagens/imovel-horto-florestal.jpg",
            "url": "https://rramosconsultoria.com.br/imovel-sao-cleto",
            "offers": {
              "@type": "Offer",
              "priceCurrency": "BRL",
              "price": "A CONSULTAR",
              "availability": "https://schema.org/InStock",
              "itemCondition": "https://schema.org/NewCondition"
            },
            "numberOfRooms": 4,
            "numberOfBathroomsTotal": 3,
            "numberOfBedrooms": 4,
            "numberOfFullBathrooms": 3,
            "numberOfHalfBathrooms": 1,
            "floorSize": {
              "@type": "QuantitativeValue",
              "value": "A CONSULTAR",
              "unitCode": "SQM"
            },
            "propertyType": "House",
            "amenityFeature": [
              {
                "@type": "LocationFeatureSpecification",
                "name": "Próximo ao Horto Florestal e Serra da Cantareira"
              },
              {
                "@type": "LocationFeatureSpecification",
                "name": "Churrasqueira e área de lazer"
              },
              {
                "@type": "LocationFeatureSpecification",
                "name": "3 vagas cobertas + 1 aberta"
              },
              {
                "@type": "LocationFeatureSpecification",
                "name": "Escritura Definitiva, aceita financiamento"
              }
            ]
          })
        }
      ]
    })

    return { meta }
  },
  data() {
    return {
      casaReginaData,
    }
  }
};
</script>

<style scoped>
.v-container {
  padding-top: 40px;
  padding-bottom: 40px;
}
</style>